<template>
    <div style="width:100%">
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="expjq" @imp="impt" @save="save" @print="print"
                    ref="SetBtn"></buttonlist>
        <!--<buttonlist @add="add" @search="search" @del="del" @reflash="reflash" @print="print" @imp="impt" @exps="expjq" @save="save" ref="SetBtn"></buttonlist>-->
        <serce :isVisible="isVisible" queryData="PartViewInfo" ref="ser" @getser="serclick"></serce>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div class="btnnowrap" style="margin-top: 2px">
                <el-button type="primary" size="mini" @click="setInvalidBatch()" :disabled="!btn.batach">{{ $t('getapi[147]') }}</el-button>
                <el-button type="primary" size="mini" @click="UpdateAccumulateLEADTIME()" :disabled="!btn.updateaccumulate">{{$t('getapi[7996]')}}</el-button>
                <el-button type="primary" size="mini" @click="imptMachData()">{{ $t('getapi[12411]') }}</el-button>
                </div>
                <el-tabs :tab-position="'top'" v-model="activeName" @tab-click="selectInfo" >
                    <el-tab-pane :label="$t('getapi[3608]')" name="0">
                        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                            <li style="width: 100%; margin-top:0px;">
                                <wTable
                                        id="xpane-0"
                                        ref="singleTable"
                                        queryData="PartViewInfo"
                                        :filter_language="['board_flag','part_status','avl_flag','isSequenceTrace','machine_flag','MP_FLAG','DUMMY_FLAG','isLotNumberTrace','isStock','key_flag','LeftOver_Flag','ce_flag','ASSIST_UNIT_FLAG','Bom_Config_Flag']"
                                        :data="dataSet"
                                        :loading="loading"
                                        :header="tableHeader"
                                        :filter_thousandth="['WEIGHT','Part_Area','CUBAGE']"
                                        @edits="editInfo" @rowdblclick="openEdit" @handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[148]')" name="1">
                        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                            <li style="width: 100%; margin-top:0px">
                                <wTable id="xpane-1" ref="singleTable1" queryData="PartViewInfo" :data="dataSet" :loading="loading"
                                        :filter_language="['board_flag','part_status','avl_flag','isSequenceTrace','machine_flag','MP_FLAG','DUMMY_FLAG','isLotNumberTrace','isStock','key_flag','LeftOver_Flag','ce_flag','ASSIST_UNIT_FLAG','Bom_Config_Flag','Is_CYCLE_CHECK','saledemandflag','So_Issue_control','LEADTIME_ManFlag','mrp_fa_flag','print_flag','msds_flag']"
                                        :filter_thousandth="['CYCLE_CHECK_INTERVAL','LEAST_PURCH_BATCH','mergeDays','REQUIRE_PERIOD',
                                        'PLANNING_PERIOD','STOCK_UPPERLIMIT','STOCK_LOWERLIMIT','PURCHASE_LEADTIME','Standard_BATCH','Year_BATCH','Produce_LEADTIME']"
                                        :header="tableHeader1" @edits="editInfo" @rowdblclick="openEdit"  @handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[167]')" name="2">
                        
                        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                            <li style="width: 100%; margin-top:0px">
                                <wTable id="xpane-2" ref="singleTable2" queryData="PartViewInfo"
                                        :filter_language="['board_flag','part_status','avl_flag','isSequenceTrace','machine_flag','MP_FLAG','DUMMY_FLAG','isLotNumberTrace','isStock','key_flag','LeftOver_Flag','ce_flag','ASSIST_UNIT_FLAG','Bom_Config_Flag']"
                                        :data="dataSet" :loading="loading"
                                        :header="tableHeader2" @edits="editInfo" @rowdblclick="openEdit"  @handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[184]')" name="3">
                        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                            <li style="width: 100%; margin-top:0px">
                                <wTable id="xpane-3" ref="singleTable3" queryData="PartViewInfo"
                                        :filter_language="['board_flag','part_status','avl_flag','isSequenceTrace','machine_flag','MP_FLAG','DUMMY_FLAG','isLotNumberTrace','isStock','key_flag','LeftOver_Flag','ce_flag','ASSIST_UNIT_FLAG','Bom_Config_Flag','keep_period_flag','part_image']"
                                        :data="dataSet" :loading="loading" :header="tableHeader3" @edits="editInfo" @rowdblclick="openEdit"  @handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6110]')" name="4">
                        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
                            <li style="width: 100%; margin-top:0px">
                                <wTable id="xpane-4" ref="singleTable4" queryData="PartViewInfo"
                                        :filter_language="['MP_FLAG','DUMMY_FLAG','isLotNumberTrace','isStock','key_flag','LeftOver_Flag','ce_flag','ASSIST_UNIT_FLAG','Bom_Config_Flag','valid_flag','issetting']"
                                        :data="dataSet" :loading="loading" :header="tableHeader4" @edits="editInfo" @rowdblclick="openEdit"  @handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click="setInvalid(1)" :disabled="!btn.usable">
                        {{ $t('getapi[147]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="setInvalid(0)" :disabled="!btn.nousable">
                        {{ $t('getapi[215]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="lookdrawing()" :disabled="!btn.lookdrawing">
                        {{ $t('getapi[7997]') }}
                    </el-button>
                </div>
                <div style="width:880px;">
                    <table>
                        <tr>
                            <td style="width:80px;max-width: 160px">{{ $t('getapi[226]') }}</td>
                            <td style="width:200px;display: flex">
                                <el-input v-model="dataSetDetail.part_code" type="text" size="mini" class="mcolor"
                                          v-if="!isEdit"></el-input>
                                <el-input v-model="dataSetDetail.part_code" type="text" size="mini" :readonly="true" class="readO"
                                          v-if="isEdit"></el-input>
                            </td>
                            <td style="width:80px;max-width: 160px">{{ $t('getapi[116]') }}</td>
                            <td colspan="7">
                                <el-input v-model="dataSetDetail.part_name" type="text" size="mini" :readonly="!btn.partname" :class="{'readO':!btn.partname==true}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[114]') }}</td>
                            <td>
                                <el-input :value="dataSetDetail.part_status == 1 ? $t('getapi[203]') : $t('getapi[231]')" type="text"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[227]') }}</td>
                            <td style="width:100px;display: flex">
                                <el-input v-model="dataSetDetail.part_version" style="width:80px" type="text"
                                          class="mcolor" v-if="!isEdit" size="mini"></el-input>
                                <el-input v-model="dataSetDetail.part_version" style="width:80px" type="text"
                                          :readonly="true" class="readO" v-if="isEdit" size="mini"></el-input>
                            </td>
                            <td style="width:80px">{{ $t('getapi[134]') }}</td>
                            <td style="width:160px;">
                                <div style="display: flex">
                                    <el-select v-model="dataSetDetail.mp_flag" :placeholder="$t('getapi[6085]')"
                                               class="mcolor" v-if="btn.mp_flag" @change="changempflag" size="mini">
                                        <el-option v-for="item in data_mp_flag" :key="item.value" :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                    <el-select
                                            v-model="dataSetDetail.mp_flag"
                                            :placeholder="$t('getapi[6085]')"
                                            v-if="!btn.mp_flag"
                                            @change="changempflag"
                                            size="mini"
                                    >
                                        <el-option v-for="item in data_mp_flag" :key="item.value" :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                    <!--<input v-model="dataSetDetail.MP_FLAG" style="width:120px" type="text" disabled="true"/>-->
                                </div>
                            </td>
                            <td style="width:80px">{{ $t('getapi[135]') }}</td>
                            <td style="width:100px">
                                <el-date-picker
                                        v-model="dataSetDetail.create_time"
                                        type="datetime"
                                        :placeholder="$t('getapi[6086]')"
                                        :readonly="isEdit" :class="{'readO':isEdit==true}"
                                        size="mini"
                                ></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs>
                    <el-tab-pane :label="$t('getapi[3608]')" :disabled="!btn.page_master">
                        <div style="width:810px;min-width:810px">
                            <table style="border-spacing: 5px;" @dblclick.stop v-if="btn.page_master">
                                <tr>
                                    <td style="width:80px;max-width: 160px">{{ $t('getapi[118]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <routejump :urlNo="2">
                                            <el-select filterable v-model="dataSetDetail.item_type_id" :disabled="!btn.readonly_page_master"
                                                       :placeholder="$t('getapi[6085]')" size="mini">
                                                <el-option v-for="item in allEngTypeArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td style="width:80px;max-width: 160px">{{ $t('getapi[128]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <routejump :urlNo="1">
                                            <el-select
                                                    filterable
                                                    v-model="dataSetDetail.part_master_unit"
                                                    :placeholder="$t('getapi[6085]')"
                                                    class="mcolor"
                                                    v-if="!isEdit"
                                                    size="mini"
                                            >
                                                <el-option v-for="item in allUnitsArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                            <el-select
                                                    filterable
                                                    :disabled="true"
                                                    v-model="dataSetDetail.part_master_unit"
                                                    :placeholder="$t('getapi[6085]')"
                                                    v-if="isEdit"
                                                    size="mini"
                                            >
                                                <el-option v-for="item in allUnitsArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td style="width:40px;max-width: 80px"></td>
                                    <td style="width:80px;max-width: 160px">{{ $t('getapi[126]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.part_stuff" type="text" size="mini"></el-input>
                                    </td>
                                    <td style="width:80px;max-width: 160px" class="alignment-right" >
                                        {{ $t('getapi[122]') }}
                                        <el-checkbox v-model="dataSetDetail.isstock"
                                                     :disabled="isEdit"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[119]') }}</td>
                                    <td>
                                        <routejump :urlNo="3">
                                            <el-select :disabled="!btn.readonly_page_master" filterable v-model="dataSetDetail.finance_type_id"
                                                       :placeholder="$t('getapi[6085]')" size="mini">
                                                <el-option v-for="item in allFANTypeArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td>{{ $t('getapi[131]') }}</td>
                                    <td>
                                        <el-input
                                                :readonly="!btn.readonly_page_master"
                                                :class="[!btn.readonly_page_master?'readO':'mcolor']"
                                                v-model="dataSetDetail.master_assist_rate"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                v-if="dataSetDetail.assist_unit_flag == true"
                                                size="mini"
                                        ></el-input>
                                        <el-input
                                                v-model="dataSetDetail.master_assist_rate"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                :readonly="dataSetDetail.assist_unit_flag != true && !btn.readonly_page_master"
                                                :class="{'readO':dataSetDetail.assist_unit_flag != true && !btn.readonly_page_master}"
                                                v-if="dataSetDetail.assist_unit_flag != true"
                                                size="mini"
                                        ></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[146]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.key_flag" true-label="1"
                                                     false-label="0"></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[6081]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.blueprint_code" type="text"
                                                  size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[121]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.dummy_flag"
                                                     @change="checkDummyAndStock"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[120]') }}</td>
                                    <td>
                                        <routejump :urlNo="4">
                                            <el-select :disabled="!btn.readonly_page_master" filterable v-model="dataSetDetail.commodity_type_id"
                                                       :placeholder="$t('getapi[6085]')" size="mini">
                                                <el-option v-for="item in allMCDSTypeArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td>{{ $t('getapi[130]') }}</td>
                                    <td>
                                        <routejump :urlNo="1">
                                            <el-select
                                                    filterable
                                                    v-model="dataSetDetail.part_assist_unit"
                                                    :placeholder="$t('getapi[6085]')"
                                                    :disabled="dataSetDetail.assist_unit_flag != true && !btn.readonly_page_master"
                                                    size="mini"
                                            >
                                                <el-option v-for="item in allUnitsArray" :key="item.Code" :label="item.Name"
                                                           :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[203]') }}
                                        <!-- !btn.readonly_page_master  -->
                                        <el-checkbox :disabled="!btn.readonly_page_master || !b_assist_unit_flag"  v-model="dataSetDetail.assist_unit_flag"
                                                     @change="assistunitflagChange"></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[133]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.page_no" type="text" size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[117]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master"  v-model="dataSetDetail.board_flag" true-label="1"
                                                     false-label="0" @change="changeBoardFlag"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[137]') }}</td>
                                    <td style="display: flex">
                                        <routejump :urlNo="5">
                                            <el-input
                                                    :disabled="!btn.readonly_page_master"
                                                    v-model="dataSetDetail.item_code"
                                                    type="text"
                                                    readonly
                                                    class="mcolor"
                                                    size="mini"
                                            >
                                                <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectItemCode()"></i>

                                            </el-input>
                                        </routejump>
                                        <!--<div style="margin: auto;color:blue"><i class="el-icon-zoom-in"
                                                                                @click="selectItem_code"></i></div>-->
                                    </td>
                                    <td>{{ $t('getapi[124]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}"  v-model="dataSetDetail.part_model" type="text" size="mini"></el-input>
                                    </td>
                                    <td></td>
                                    <td>{{ $t('getapi[138]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}"  v-model="dataSetDetail.weight" type="number" autocomplete="off" title="" @mousewheel.native.prevent class="alignment-right"
                                                  size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[4123]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.bom_config_flag" true-label="1"
                                                     false-label="0"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[6087]') }}</td>
                                    <td class="alignment-right">
                                        <el-select v-model="tracetype" placeholder="请选择" @change="changeTraceType"
                                                   size="mini" :disabled="dataSetDetail.part_status == 1 || !btn.readonly_page_master">
                                            <el-option :key="0" :label="$t('getapi[490]')" :value="0"></el-option>
                                            <el-option :key="1" :label="$t('getapi[1763]')" :value="1"></el-option>
                                            <el-option :key="2" :label="$t('getapi[1764]')" :value="2"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{ $t('getapi[4187]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.part_spec" type="text" size="mini"></el-input>
                                    </td>
                                    <td></td>
                                    <td>{{ $t('getapi[140]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.CUBAGE" type="number" autocomplete="off" title="" @mousewheel.native.prevent class="alignment-right"
                                                  size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        AVL
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.avl_flag" true-label="1"
                                                     false-label="0"></el-checkbox>
                                    </td>

                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[145]') }}</td>
                                    <td colspan="4">
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.products" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[139]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_master" :class="{'readO':!btn.readonly_page_master}" v-model="dataSetDetail.part_area" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right">
                                        {{ $t('getapi[144]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.leftover_flag" true-label=1
                                                     false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                   <td>{{ $t('getapi[6403]') }}</td>
                                    <td>
                                        <el-input :readonly="true" class="readO"  v-model="dataSetDetail.item_duty_person" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[12513]') }}</td>
                                    <td>
                                        <el-date-picker
                                                v-model="dataSetDetail.confirm_date"
                                                type="date"
                                                size="mini"
                                                style="width:100%"
                                                :readonly="!btn.readonly_page_master"
                                                :class="{'readO':!btn.readonly_page_master}"
                                                value-format="yyyy/MM/dd"
                                        ></el-date-picker>
                                    </td>
                                    <td>{{ $t('getapi[12512]') }}</td>
                                    <td>
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.malaysia_canmake" true-label="1" false-label="0"></el-checkbox>
                                    </td>

                                    
                                    <td class="alignment-right">
                                    </td>
                                     <td class="alignment-right">
                                        {{ $t('getapi[8047]') }}
                                        <el-checkbox :disabled="!btn.readonly_page_master" v-model="dataSetDetail.ce_flag" true-label=1
                                                     false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td> {{ $t('getapi[6052]') }}</td>
                                    <td>
                                        <el-input  v-model="dataSetDetail.prefix" type="text" size="mini"></el-input>
                                    </td>
                                    <td> {{ $t('getapi[7127]') }}</td>
                                    <td>
                                        <el-input  v-model="dataSetDetail.suffix" type="text" size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right" colspan="4">
                                        {{ $t('getapi[12589]') }}
                                        <el-checkbox v-model="dataSetDetail.machine_flag" :true-label=1
                                                     :false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td> {{ $t('getapi[12579]') }}</td>
                                    <td>
                                        <el-input  v-model="dataSetDetail.digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td> {{ $t('getapi[12580]') }}</td>
                                    <td>
                                        <el-input v-model="dataSetDetail.currentvalue" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right" colspan="4">
                                        {{ $t('getapi[12605]') }}
                                        <el-checkbox v-model="dataSetDetail.nodirect_move_cross_plan" true-label=1
                                                     false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[12583]') }}</td>
                                    <td>
                                        <el-checkbox  v-model="dataSetDetail.mrp_fa_flag" :true-label=1
                                                      :false-label=0></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[12962]') }}</td>
                                    <td>
                                        <el-input v-model="dataSetDetail.cus_draw_version" type="text"
                                                  size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right" colspan="7">
                                        {{ $t('getapi[12720]') }}
                                        <el-checkbox v-model="dataSetDetail.print_flag" :true-label=1
                                                     :false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[12963]') }}</td>
                                    <td>
                                        <el-input v-model="dataSetDetail.cusitem_name" type="text"
                                                  size="mini"></el-input>
                                    </td>
                                    <td class="alignment-right" colspan="9">
                                        {{ $t('getapi[13322]') }}
                                        <el-checkbox v-model="dataSetDetail.msds_flag" :true-label=1
                                                     :false-label=0></el-checkbox>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[148]')" :disabled="!btn.page_schedule">
                        <div style="width:740px;min-width:740px">
                            <table style="border-spacing: 5px" @dblclick.stop v-if="btn.page_schedule" >
                                <tr>
                                    <td style="width:60px;max-width: 120px">{{ $t('getapi[221]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-select filterable v-model="dataSetDetail.planning_code"
                                                   :placeholder="$t('getapi[6085]')" :disabled="!btn.readonly_page_schedule" size="mini">
                                            <el-option v-for="item in schTypeArray" :key="item.Code" :label="item.Name"
                                                       :value="item.Code"></el-option>
                                        </el-select>
                                    </td>
                                    <td style="width:60px;max-width:120px">{{ $t('getapi[163]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <routejump :urlNo="6">
                                            <el-input
                                                    v-model="dataSetDetail.plannername"
                                                    type="text"
                                                    readonly
                                                    size="mini"
                                            >
                                                <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectPlanner()"></i>

                                            </el-input>
                                        </routejump>
                                    </td>
                                    <td style="width:70px;max-width:140px">{{ $t('getapi[158]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="[!btn.readonly_page_schedule?'readO':'mcolor']" v-model="dataSetDetail.purchase_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  size="mini"></el-input>
                                    </td>
                                    <td style="width:70px;;max-width:140px">{{ $t('getapi[8058]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input :readonly="dataSetDetail.LEADTIME_ManFlag == 0" :class="{'readO':dataSetDetail.LEADTIME_ManFlag == 0}" v-model="dataSetDetail.Accumulate_LEADTIME" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[219]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.least_purch_batch" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[156]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.stock_upperlimit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[161]') }}</td>
                                    <td style="display: flex">
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="[!btn.readonly_page_schedule?'readO':'mcolor']" v-model="dataSetDetail.produce_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[8059]') }}</td>
                                    <td>
                                        <el-checkbox v-model="dataSetDetail.LEADTIME_ManFlag" :true-label=1 :false-label=0></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[159]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.standard_batch" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[6009]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.stock_lowest" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[6006]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.qc_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[12606]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.raw_material_time" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[164]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.package_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[165]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.digitscale" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[155]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.planning_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[12607]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.total_lead_time" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[153]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.mergedays" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[136]') }}</td>
                                    <td style="display: flex">
                                        <el-select filterable v-model="dataSetDetail.abc_category" :disabled="!btn.readonly_page_schedule"
                                                   :placeholder="$t('getapi[6085]')" class="mcolor" size="mini">
                                            <el-option :key="'A'" label="A" :value="'A'"></el-option>
                                            <el-option :key="'B'" label="B" :value="'B'"></el-option>
                                            <el-option :key="'C'" label="C" :value="'C'"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{ $t('getapi[154]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.require_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[6007]') }}</td>
                                    <td>
                                        <el-checkbox :disabled="!btn.readonly_page_schedule" v-model="dataSetDetail.so_issue_control" size="mini" true-label="1"
                                                     false-label="0"></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[2548]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.stock_lowerlimit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[162]') }}</td>
                                    <td>
                                        <el-checkbox :disabled="!btn.readonly_page_schedule" v-model="dataSetDetail.is_cycle_check"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[166]') }}</td>
                                    <td>
                                        <el-checkbox :disabled="!btn.readonly_page_schedule" v-model="dataSetDetail.saledemandflag"></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[6008]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.safe_days" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[6088]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.cycle_check_interval" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[2326]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_schedule" :class="{'readO':!btn.readonly_page_schedule}" v-model="dataSetDetail.routing_sequence" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[6419]') }}</td>
                                    <td>
                                        <el-select filterable v-model="dataSetDetail.method"  size="mini">
                                            <el-option :label="$t('getapi[7998]')" value="发料量"></el-option>
                                            <el-option label="MRP" value="MRP"></el-option>
                                        </el-select>
                                    </td>
                                </tr>


                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[167]')" :disabled="!btn.page_cost">
                        <div style="width:690px;min-width:690px">
                            <table style="border-spacing: 5px" v-if="btn.page_cost">
                                <tr>
                                    <td style="width:70px;max-width:140px">{{ $t('getapi[223]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-select filterable v-model="dataSetDetail.cost_mode_id"
                                                   :placeholder="$t('getapi[6085]')" :disabled="!btn.readonly_page_cost" size="mini">
                                            <el-option v-for="item in allCostsArray" :key="item.Code" :label="item.Name"
                                                       :value="item.Code"></el-option>
                                        </el-select>
                                    </td>
                                    <td style="width:70px;max-width:140px">{{ $t('getapi[174]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input :readonly="!btn.readonly_page_cost" :class="{'readO':!btn.readonly_page_cost}" v-model="dataSetDetail.average_purch_cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td style="width:70px;max-width:140px">{{ $t('getapi[169]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <routejump :urlNo="7">
                                            <el-select
                                                    :disabled="!btn.readonly_page_cost"
                                                    filterable
                                                    v-model="dataSetDetail.category_first"
                                                    :placeholder="$t('getapi[6085]')"
                                                    @visible-change="changeCateroty"
                                                    class="mcolor"
                                                    size="mini"
                                            >
                                                <el-option v-for="item in partCategory_AArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input  v-model="dataSetDetail.category_first" type="text" :readonly="true" class="readO"
                                                  size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[173]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.readonly_page_cost" :class="{'readO':!btn.readonly_page_cost}"  v-model="dataSetDetail.lately_purch_cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[180]') }}</td>
                                    <td>
                                        <el-input v-model="dataSetDetail.inv_cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                  :readonly=" !btn.inv_cost_qx" :class="{'readO':!btn.inv_cost_qx}" size="mini"></el-input>
                                    </td>
                                    <td>
                                        <span style="white-space: nowrap">{{ $t('getapi[170]') }}</span>
                                    </td>
                                    <td>
                                        <routejump :urlNo="7">
                                            <el-select
                                                    :disabled="!btn.readonly_page_cost"
                                                    filterable
                                                    v-model="dataSetDetail.category_second"
                                                    :placeholder="$t('getapi[6085]')"
                                                    @visible-change="changeCateroty1"
                                                    size="mini"
                                            >
                                                <el-option v-for="item in partCategory_BArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td>
                                        <el-input   v-model="dataSetDetail.category_second" type="text" :readonly="true" class="readO"
                                                  size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[175]') }}</td>
                                    <td>
                                        <el-input  v-model="dataSetDetail.multiple_material_cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="!btn.readonly_page_cost" :class="{'readO':!btn.readonly_page_cost}" size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[181]') }}</td>
                                    <td>
                                        <el-input  :readonly="!btn.inv_cost_qx" :class="{'readO':!btn.inv_cost_qx}" v-model="dataSetDetail.inv_cost_material" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="costChange" size="mini"></el-input>
                                    </td>
                                    <td>
                                        <span style="white-space: nowrap">{{ $t('getapi[171]') }}</span>
                                    </td>
                                    <td>
                                        <routejump :urlNo="7">
                                            <el-select :disabled="!btn.readonly_page_cost"  filterable v-model="dataSetDetail.category_third"
                                                       :placeholder="$t('getapi[6085]')" size="mini">
                                                <el-option v-for="item in partCategory_CArray" :key="item.Code"
                                                           :label="item.Name" :value="item.Code"></el-option>
                                            </el-select>
                                        </routejump>
                                    </td>
                                    <td>
                                        <el-input   v-model="dataSetDetail.category_third" type="text" :readonly="true" class="readO"
                                                  size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[176]') }}</td>
                                    <td>
                                        <el-input  v-model="dataSetDetail.multiple_man_cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="!btn.readonly_page_cost" :class="{'readO':!btn.readonly_page_cost}" size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[182]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.inv_cost_qx" :class="{'readO':!btn.inv_cost_qx}" v-model="dataSetDetail.inv_cost_man" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="costChange" size="mini"></el-input>
                                    </td>
                                    <td colspan="3">
                                        {{ $t('getapi[222]') }}
                                        <el-checkbox  :disabled="!btn.readonly_page_cost" v-model="dataSetDetail.isLotNumberTrace"></el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[177]') }}</td>
                                    <td>
                                        <el-input
                                                v-model="dataSetDetail.multiple_change_charge_cost"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                :readonly="!btn.readonly_page_cost"
                                                :class="{'readO':!btn.readonly_page_cost}"
                                                size="mini"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[183]') }}</td>
                                    <td>
                                        <el-input :readonly="!btn.inv_cost_qx" :class="{'readO':!btn.inv_cost_qx}" v-model="dataSetDetail.inv_cost_charge" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="costChange" size="mini"></el-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[178]') }}</td>
                                    <td>
                                        <el-input
                                                v-model="dataSetDetail.multiple_solid_charge_cost"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                :readonly="!btn.readonly_page_cost"
                                                :class="{'readO':!btn.readonly_page_cost}"
                                                size="mini"
                                        ></el-input>
                                    </td>
                                    <td colspan="5"></td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6110]')" :disabled="!btn.page_part">
                        <div style="display: flex">
                            <div style="width:600px;min-width:600px">
                                <table style="border-spacing: 5px">
                                    <tr>
                                        <td><el-button type="primary" size="mini" @click="setEffective(1)" :disabled="!btn.p_part_effective">{{ $t('getapi[1170]') }}</el-button></td>
                                        <td><el-button type="primary" size="mini" @click="setEffective(0)"  :disabled="!btn.p_part_invalid">{{ $t('getapi[1171]') }}</el-button></td>
                                    </tr>
                                    <tr>
                                        <td style="width:80px;max-width:160px">{{ $t('getapi[552]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input  v-model="dataSetDetail.p_part_valid_flag"  :readonly="true" class="readO" type="text" size="mini"></el-input>
                                        </td>
                                        <td style="width:80px;max-width:160px">{{ $t('getapi[7140]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <routejump :urlNo="8">
                                                <el-select filterable v-model="dataSetDetail.p_part_sort_id" :disabled="!btn.page_part_readonly"
                                                        :placeholder="$t('getapi[6085]')" size="mini">
                                                    <el-option v-for="item in schPPpartTypeListArray" :key="item.Code"
                                                            :label="item.Name" :value="item.Code"></el-option>
                                                </el-select>
                                            </routejump>
                                        </td>
                                        <td style="width:80px;max-width:160px">{{ $t('getapi[1166]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <routejump :urlNo="1">
                                                <el-select filterable
                                                        v-model="dataSetDetail.p_part_pur_measurementunit"
                                                        :placeholder="$t('getapi[6085]')"
                                                        class="mcolor"
                                                        size="mini"
                                                        :disabled="!btn.page_part_readonly"
                                                >
                                                    <el-option v-for="item in allUnitsArray" :key="item.Code"
                                                            :label="item.Name" :value="item.Name"></el-option>
                                                </el-select>
                                            </routejump>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[160]') }}</td>
                                        <td>
                                            <el-input :readonly="!btn.page_part_readonly" :class="{'readO':!btn.page_part_readonly}"  v-model="dataSetDetail.p_part_year_quantity" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1167]') }}</td>
                                        <td>
                                            <el-input v-model="dataSetDetail.p_part_buyer" type="text" :disabled="!btn.page_part_readonly" readonly class="mcolor"  size="mini">
                                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee()"></i>
                                            </el-input>
                                            <!-- <el-input v-model="dataSetDetail.p_part_buyer" type="text" size="mini"></el-input> -->
                                        </td>

                                        <td>{{ $t('getapi[124]') }}</td>
                                        <!--label="型号"-->
                                        <td ><el-input  v-model="dataSetDetail.part_spec" type="text"  :readonly="true" class="readO" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[125]') }}</td>
                                        <!--label="规格"-->
                                        <td ><el-input   v-model="dataSetDetail.part_stuff" type="text"   :readonly="true" class="readO" size="mini"></el-input></td>
                                        <td>{{ $t('getapi[409]') }}</td>
                                        <td><el-input  v-model="dataSetDetail.p_part_create_time" :readonly="true" class="readO" type="text" size="mini"></el-input></td>
                                        <td>{{ $t('getapi[410]') }}</td>
                                        <td><el-input   v-model="dataSetDetail.p_part_create_person"  :readonly="true" class="readO" type="text" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[734]') }}</td>
                                        <td><el-input  v-model="dataSetDetail.p_part_modify_time" :readonly="true" class="readO" type="text" size="mini"></el-input></td>

                                        <td>{{ $t('getapi[733]') }}</td>
                                        <td><el-input   v-model="dataSetDetail.p_part_modify_person"  :readonly="true" class="readO" type="text" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[143]') }}</td>
                                        <td colspan="5"><el-input   v-model="dataSetDetail.p_part_remark" type="text" size="mini"></el-input></td>
                                    </tr>
                                </table>
                            </div>

                        </div>
                            <el-tabs :tab-position="'top'" type=""  style="margin-top:-20px">
                                <vxe-table
                                        :data="dataPPartDetail"
                                        :height="tableHeight-280"
                                        show-overflow="tooltip"
                                        border
                                        size="mini"
                                        header-row-class-name="headerclass"
                                        style="width: 100%;"
                                >
                                    <!-- <vxe-table-column show-footer-overflow field="exclusively_id"  visible="false"></vxe-table-column> -->
                                    <vxe-table-column show-footer-overflow field="vender_code" :title="$t('getapi[1196]')" width="120px"></vxe-table-column>
                                    <vxe-table-column show-footer-overflow field="vender_name" :title="$t('getapi[1197]')" width="150px"></vxe-table-column>
                                    <vxe-table-column show-footer-overflow field="prioritylevel" :title="$t('getapi[6032]')" width="80px">
                                        <template slot-scope="scope">
                                            <el-input size="mini" v-model="scope.row.prioritylevel" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="!btn.page_part_readonly" :class="{'readO':!btn.page_part_readonly}"></el-input>
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column show-footer-overflow field="rate" title="占比" width="60px">
                                        <template slot-scope="scope">
                                            <el-input size="mini" v-model="scope.row.rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="!btn.page_part_readonly" :class="{'readO':!btn.page_part_readonly}"></el-input>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[12400]')" :disabled="!btn.page_part_mach">
                        <div style="display: flex">
                            <div style="width: 600px;min-width:600px">
                                <table style="border-spacing: 5px">
                                    
                                    <tr>
                                        <td style="width:100px;max-width:200px">{{ $t('getapi[12409]') }}</td>
                                        <td style="width:120px;min-width:120px"><el-input  v-model="dataSetDetail.mach_stuff" type="text" size="mini"></el-input></td>
                                        <td style="width:100px;max-width:200px">{{ $t('getapi[12404]') }}</td>
                                        <td style="width:120px;min-width:120px"><el-input   v-model="dataSetDetail.mach_width"   type="text" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[12401]') }}</td>
                                        <td ><el-input  v-model="dataSetDetail.mach_type" type="text"  size="mini"></el-input></td>
                                        <td>{{ $t('getapi[12405]') }}</td>
                                        <td><el-input  v-model="dataSetDetail.mach_length"  type="text" size="mini"></el-input></td>
                                   </tr>
                                    <tr>
                                        <td>{{ $t('getapi[12402]') }}</td>
                                        <td><el-input  v-model="dataSetDetail.mach_out_diam"  type="text" size="mini"></el-input></td>
                                        <td>{{ $t('getapi[12406]') }}</td>
                                        <td><el-input   v-model="dataSetDetail.mach_thk"  type="text" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[12403]') }}</td>
                                        <td ><el-input   v-model="dataSetDetail.mach_in_diam" type="text"    size="mini"></el-input></td>
                                        <td>{{ $t('getapi[12407]') }}</td>
                                        <td><el-input   v-model="dataSetDetail.mach_sectionbar"  type="text" size="mini"></el-input></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[12408]') }}</td>
                                        <td colspan="5"><el-input   v-model="dataSetDetail.mach_remarks" type="text" size="mini"></el-input></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[8958]')" v-if="btn.page_free">
                        <div style="background: white;white-space: nowrap;overflow: auto">
                            <el-button type="primary" size="mini" @click.native.prevent="addG">
                                {{$t('getapi[878]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click.native.prevent="batchDelG" :disabled="selectDataG.length != 1">
                                {{$t('getapi[40]')}}
                            </el-button>
                        </div>
                        <vxe-table
                                :data="dataGDetail"
                                :height="tableHeight-180"
                                show-overflow="tooltip"
                                border
                                resizable
                                size="mini"
                                header-row-class-name="headerclass"
                                @checkbox-change="handleSelectionChangeG"
                                :row-class-name="tableRowClassNameG"
                                style="width: 100%;"
                        >
                            <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="freevalue" :title="$t('getapi[8959]')" width="100px">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.freevalue"></el-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="isenable" :title="$t('getapi[6158]')" width="100px">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.isenable" :true-label=1 :false-label=0>
                                    </el-checkbox>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[224]')" :disabled="!btn.page_quality">
                        <div style="width:800px;;display: flex">
                            <div style="width: 400px;">
                                <table style="border-spacing: 5px" v-if="btn.page_quality">
                                    <tr>
                                        <td style="width:60px">{{ $t('getapi[186]') }}</td>
                                        <td style="width:120px">
                                            <el-input :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.check_std" type="text"
                                                      size="mini"></el-input>
                                        </td>
                                        <td style="width:100px">{{ $t('getapi[191]') }}</td>
                                        <td style="width:120px">
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.stuff_manuf_code" type="text"
                                                      size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[187]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.quality_std" type="text"
                                                      size="mini"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[6082]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.stuff_manuf_name" type="text"
                                                      size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[189]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.material_standard" type="text"
                                                      size="mini"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[188]') }}</td>
                                        <td>
                                            <routejump :urlNo="9">
                                                <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.cargoposition_code" type="text" size="mini">
                                                          <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectCargo()"></i>
                                                </el-input>
                                            </routejump>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[225]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.keep_longest_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                      class="alignment-right" size="mini"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[190]') }}</td>
                                        <td>
                                            <el-checkbox  :disabled="!btn.readonly_page_quality" v-model="dataSetDetail.keep_period_flag"></el-checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[12813]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.customs_hscode" type="text" @mousewheel.native.prevent
                                                       size="mini"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[13292]') }}</td>
                                        <td>
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.country_origin" type="text" @mousewheel.native.prevent
                                                       size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[13291]') }}</td>
                                        <td colspan="3">
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.decl_elem" type="text" @mousewheel.native.prevent
                                                       size="mini"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[13293]') }}</td>
                                        <td colspan="3">
                                            <el-input  :readonly="!btn.readonly_page_quality" :class="{'readO':!btn.readonly_page_quality}" v-model="dataSetDetail.decl_productname" type="text" @mousewheel.native.prevent
                                                       size="mini"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div style="width: 400px">
                                <el-upload
                                        action=""
                                        list-type="picture-card"
                                        :on-preview="handlePictureCardPreview"
                                        :http-request="uploadFile"
                                        :on-remove="handleRemove"
                                        :on-change="fileChange"
                                        :header="token"
                                        :file-list="fileList"
                                        :auto-upload="true"
                                        :limit="1"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog v-dialogDrag :visible.sync="dialogVisible" :modal-append-to-body="false">
                                    <el-image :src="dialogImageUrl" alt=""></el-image>
                                </el-dialog>
                                <!--<el-image style="width: 100px; height: 100px" :src="url" fit="scale-down"></el-image>-->
                            </div>
                        </div>
                        <div>
                            <el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[12814]')}}</span></el-divider>
                        </div>
                        <div style="width:800px;">
                            <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl"
                                        :on-preview="handlePreview"
                                        :on-remove="handlehsRemove"
                                        :on-change="handleChange"
                                        :on-success="handleSuccess"
                                        :on-error="handleError"
                                        :before-upload="beforeAvatarUpload"
                                        :file-list="fileHSList"
                                        :data="fileparm"
                                        :limit="1"
                                >
                                    <el-button slot="trigger" :disabled="!btn.customs_hs" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                                    <div slot="tip" class="el-upload__tip"></div>
                                </el-upload>
                                <el-table
                                        :data="dataHSList"
                                        v-loading="loading"
                                        :highlight-current-row="false"
                                        show-overflow-tooltip="true"
                                        border
                                        stripe
                                        size="mini"
                                        header-row-class-name="headerclass"
                                >
                                    <el-table-column show-overflow-tooltip prop="Node_Name"
                                                     :label="$t('getapi[3590]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Type"
                                                     :label="$t('getapi[6423]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Size"
                                                     :label="$t('getapi[7875]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Person"
                                                     :label="$t('getapi[6425]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Time"
                                                     :label="$t('getapi[6426]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="operate" :label="$t('getapi[6048]')">
                                        <template slot-scope="scope">
                                            <el-button @click.native.prevent="open(scope)"  type="text" size="mini">{{
                                                $t('getapi[3611]') }}
                                            </el-button>
                                            <el-button @click.native.prevent="filedel(scope)"  :disabled="!btn.customs_hs" type="text" size="mini">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                        </div>


                    </el-tab-pane>
                    <!-- 采购件信息 -->
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[100, 200, 300, 400,1000]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 计划员 -->
        <selector :isVisible="isVisiblePlanner" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'Basic/GetPeopleList'" @callback="getPlanner" ref="planner"></selector>
        <!-- 项目代号 -->
        <selector :isVisible="isVisibleItem_code" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'Basic/GetENGITEMList'" @callback="getItemCode" ref="itemcode"></selector>
        <!-- 采购员 -->
        <selector :isVisible="employeeVisible" :isBatch=false :selectType="0" :isSplitPage="true"
			:postUrl="'/Basic/GetBuyerDataList'" @callback="getemployee" ref="employee"></selector>
        <!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="title" queryData="PartViewInfo" :tabNo="tabNo" ref="ctab" @getctab="sortclick"></ctable>

        <!-- 默认货位 -->
        <selector :isVisible="cargoVisible" :isBatch=false :selectType="0" :isSplitPage="true"
			:postUrl="'/Eng/Parts/GetPartDefCargoPPopupList'" @callback="getcargo" ref="cargo"></selector>

    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'mater',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                }
            },
            tableOption1() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-500,
                    maxHeight: this.$windowSize.tableHeight3-500,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
            tableHeight1() {
                return this.$windowSize.tableHeight3 - 300
            },
        },
        watch: {
            windowWidth(newVal) {
                console.log('窗口宽度变化:', newVal)
            }
        },
        data() {
            return {
                // tableOption: {
                //     border: true,
                //     height: this.$windowSize.tableHeight3-Common.reduceTableHeight1, // 主表高度ss
                //     maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1, // 主表高度
                // },
                selectid: '',
                employeeVisible: false,
                cargoVisible:false,
                dataSet: [], // 主表数据
                sch_dataSet: [], // 主表数据
                code: '', // 唯一编码
                oldrow: {},
                iscontinuedblclick: true,
                activeName: '0', // 当前选择的分页
                oldSelectIndex: '',
                isVisible: false, // 查询列表是否显示
                queryDataSet: [], // 查询数组
                userData: [], // 用户信息
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('mater'), // 当前页数据量
                total: 0, // 数据总量
                currentPage: 1, // 当前页
                currentRow: '', //
                loading: false, // 主表加载状态
                //tableHeight: this.$windowSize.tableHeight3, // 主表高度
                reduceTableHeight: Common.reduceTableHeight1,
                dataSetDetail: {}, // 编辑页面数据详情
                dataPPartDetail: {},//采购件相关采购占比
                dataGDetail:[],//自由项
                oldDataSetDetail: {}, // 记录老数据
                part_status: true, // 物料状态是否可用开关状态
                queryData: [], // 查询数组
                SelectIndex: 0, // 标签页下标
                selectIDData: [], // 选择的数据的ID集合
                selectData: [],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: false, // 是否新增
                addoredit: 0, // 1新增2：修改
                isVisiblePlanner: false, // 是否显示计划员列表
                pageIndexPlanner: 1, // 当前页
                pageSizePlanner: 50, // 当前页数据量
                querykeyPlanner: '', // 关键字查询
                totalPlanner: '', //
                cachePlanner: '',
                cachePlanner_id: '',
                isVisibleItem_code: false, // 是否显示项目代号列表
                pageIndexItem_code: 1, // 当前页
                pageSizeItem_code: 50, // 当前页数据量
                querykeyItem_code: '', // 关键字查询
                cacheItem_code: '',
                totalItem_code: '',
                token: '',
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                file: null,

                allEngTypeArray: [],
                allFANTypeArray: [],
                allMCDSTypeArray: [],
                allUnitsArray: [],
                allCostsArray: [],
                partCategory_AArray: [],
                partCategory_BCArray: [],
                partCategory_BArray: [],
                partCategory_CArray: [],
                ENGITEMListArray: [],
                peopleListArray: [],
                schPPpartTypeListArray: [],
                schTypeArray: [],
                DbTbNames: '',
                clicks: false,
                data_mp_flag: [
                    {
                        value: 0,
                        label: this.$t('getapi[235]')//'采购'
                    },
                    {
                        value: 1,
                        label: this.$t('getapi[242]')//'自制'
                    }
                ],
                btn:{
                    //批量设为可用
                    batach:false,
                    //更新所有料累积生产提前期
                    updateaccumulate:false,
                    //查看图纸
                    lookdrawing:false,
                    //设为可用
                    usable:false,
                    //设为不可用
                    nousable:false,
                    //基础信息
                    page_master:true,
                    //只读基础信息
                    readonly_page_master:true,
                    //计划相关
                    page_schedule:true,
                    //只读计划相关
                    readonly_page_schedule:true,
                    //成本相关
                    page_cost:true,
                    //只读成本相关
                    readonly_page_cost:true,
                    //其它
                    page_quality:true,
                    //只读其它
                    readonly_page_quality:true,
                    //表头
                    page_header:true,
                    //物料类别
                    mpflag: true,
                    partname: true,
                    partversion: true,
                    //当前库存成本
                    inv_cost:false,
                    inv_cost_qx:false,
                    //采购件相关
                    page_part:true,
                    //采购件相关内容只读
                    page_part_readonly:true,
                    //采购件有效
                    p_part_effective:true,
                    //采购件无效
                    p_part_invalid:true,
                    //自由项
                    page_free: false,
                    //机加工选项卡
                    page_part_mach:false,
                    //海关HS
                    customs_hs:false,
                },
                tabNo:"0",
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                tableHeader3: [],
                tableHeader4: [],
                title:"",
                timeId: null,
                b_assist_unit_flag:true,
                selectDataG:[],//自由项选择
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                isPopupVisible: false,
                // 上传清单
                uploadurl: '',
                fileparm: {
                    code: '',
                    data_type: 25,
                    Login_Group:'',
                    Login_DB:'',
                },
                fileHSList: [],
                dataHSList:[],//附件

            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if(form.name=='home' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.Part_Code,
                        query_field_name: "part_code",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.pageIndex,
                        PageSize: vm.pageSize,
                        SelectIndex: vm.SelectIndexs,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/Parts/DataList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.dataSet = res.DataContent;
                            vm.total = res.Totals;
                            vm.loading = false;
                            vm.DbTbNames = res.DbTbNames;
                            vm.isEdit = true;
                            if(vm.dataSet.length == 1){
                                vm.getDetail(vm.dataSet[0].Exclusively_ID)
                            }
                        } else {
                            // that.$message.error(res.Msg);
                            vm.loading = false;
                        }
                    });
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == '2_srview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.Part_Code,
                        query_field_name: "part_code",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    arr.push({
                        query_Condition: data.Part_version,
                        query_field_name: "part_version",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.pageIndex,
                        PageSize: vm.pageSize,
                        SelectIndex: vm.SelectIndexs,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/Parts/DataList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.dataSet = res.DataContent;
                            vm.total = res.Totals;
                            vm.loading = false;
                            vm.DbTbNames = res.DbTbNames;
                            vm.isEdit = true;
                            if(vm.dataSet.length == 1){
                                vm.getDetail(vm.dataSet[0].Exclusively_ID)
                            }
                        } else {
                            // that.$message.error(res.Msg);
                            vm.loading = false;
                        }
                    });
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'BOM' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    vm.isEdit = true;
                    vm.getDetail(data.id)
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        created() {

        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                this.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    this.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })

        },
        mounted: function () {
            let that = this;
            that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            that.colsort();
            that.$processdata.pushModelCache('mater', that)
            that.userData = sessionStorage.getItem('userData');
            that.allEngTypeArray = Array.methods.getAllEngType();
            that.allFANTypeArray = Array.methods.getAllFANType();
            that.allMCDSTypeArray = Array.methods.getAllMCDSType();
            that.allUnitsArray = Array.methods.getAllUnits();
            that.allCostsArray = Array.methods.getAllCosts();
            that.partCategory_AArray = Array.methods.getPartCategory_A();
            that.schPPpartTypeListArray = Array.methods.getSchPPpartTypeList();
            that.schTypeArray = Array.methods.getSchType();
            that.token = JSON.parse(that.userData).token;
            that.oldDataSetDetail = JSON.stringify(that.dataSetDetail)
            that.$limits.dragControllerDiv();
            that.confirmAdd();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[56]"),this.$t("getapi[18]"));
            },
            
            handlehsRemove(file, fileHSList) {
                console.log(file, fileHSList);
            },
            handlePreview(file) {
                let that = this;
                console.log("上传2");
                that.fileparm.code = that.dataSetDetail.exclusively_id;
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            
            handleChange(file, fileHSList) {
                let that = this;
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } 
                }
            },
            handleSuccess(res, file, fileHSList) {
                let that = this;
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getDetail(that.code);
                    that.$refs.upload.clearFiles();
                }
            },
            handleError(err, file, fileHSList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            beforeAvatarUpload(file) {
                let that = this;
                that.fileparm.code = that.dataSetDetail.exclusively_id;
                if (that.dataSetDetail.exclusively_id == '' || that.dataSetDetail.exclusively_id == null) {
                    that.$message.error(that.$t('getapi[9056]'));//单据号不能为空
                    return false;
                }
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                    return true;
            },
            open(row) {
                let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },            
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = '';
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.path == 'undefined' ? '' : row.row.path;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.dataHSList.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            tableRowClassNameG({row, rowIndex}) {
                row.index = rowIndex;
            },
            // 修改表格顺序
            opentable(){
                // console.log("测试:"+this.tabNo);
                this.$refs.ctab.clearInputs(true);
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('PartViewInfo',that.tabNo,PFileds=>{
                    if(that.tabNo==0){
                        that.tableHeader=PFileds;		
                    }
                    else if(that.tabNo==1){
                        that.tableHeader1=PFileds;		
                    }
                    else if(that.tabNo==2){
                        that.tableHeader2=PFileds;		
                    }
                    else if(that.tabNo==3){
                        that.tableHeader3=PFileds;		
                    }
                    else if(that.tabNo==4){
                        that.tableHeader4=PFileds;		
                    }
                });
            },
            sortclick(val){                
                let that = this;
                if(val==1){
                    this.colsort();
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = '100%';
                } else {
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                let that = this;
                if(row == ''){
                    return
                }
                if (that.SelectIndex == 0) {
                    this.$refs.singleTable.setCurrentRow(row);
                } else if (that.SelectIndex == 1) {
                    this.$refs.singleTable1.setCurrentRow(row);
                } else if (that.SelectIndex == 2) {
                    this.$refs.singleTable2.setCurrentRow(row);
                } else if (that.SelectIndex == 3) {
                    this.$refs.singleTable3.setCurrentRow(row);
                }else if (that.SelectIndex == 4) {
                    this.$refs.singleTable4.setCurrentRow(row);
                }
            },
            handleCurrentChanges(val) {
                let that = this;
                let result = this.dataSet.findIndex(item => item.Exclusively_ID === val.Exclusively_ID);
                let fsd = null;
                if (that.SelectIndex == 0) {
                    fsd = document.getElementsByClassName('fsd');
                } else if (that.SelectIndex == 1) {
                    fsd = document.getElementsByClassName('fsd1');
                } else if (that.SelectIndex == 2) {
                    fsd = document.getElementsByClassName('fsd2');
                } else if (that.SelectIndex == 3) {
                    fsd = document.getElementsByClassName('fsd3');
                }
                fsd[result].focus();
                that.currentRow = val;
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                //只读权
                if (that.$limits.authority('plv2', 30, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 30, 1) == 2) {
                    if (that.$limits.authority('plv3', 30,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 30, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 30, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 29, 1) >0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
                if (that.$limits.authority('plv2', 39, 1) >0) {
                    that.$refs.SetBtn.SetOneBtnEnable('import',true);
                }
                else{
                    that.$refs.SetBtn.SetOneBtnEnable('import',false);
                }
                that.selectbtn();            
            },
            selectbtn() {
                let that = this;
                that.btn.updateaccumulate=true;
                //查看图纸
                that.btn.lookdrawing=true;                
                //批量设为可用
                that.btn.batach=true;
                //设为可用
                that.btn.usable=true;
                //设为不可用
                that.btn.nousable=true;
                //基础信息
                that.page_master=true;
                //计划相关
                that.btn.page_schedule=true;
                //成本相关
                that.btn.page_cost=true;
                //其它
                that.btn.page_quality=true;
                 //只读基础信息
                that.btn.readonly_page_master=true;
                //只读计划相关
                that.btn.readonly_page_schedule=true;
                //只读成本相关
                that.btn.readonly_page_cost=true;
                //只读其它
                that.btn.readonly_page_quality=true;
                //当前库存成本
                that.btn.inv_cost=true;
                that.btn.inv_cost_qx=true;
                //采购件相关
                that.btn.page_part=false;
                that.btn.page_part_mach=false;
                //采购件相关内容只读
                that.btn.page_part_readonly=false;
                //采购件有效
                that.btn.p_part_effective=false;
                //采购件无效
                that.btn.p_part_invalid=false;
                //自由项相关
                that.btn.page_free = false;
                that.btn.customs_hs=false;

                if (that.$limits.authority('plv4', 586, 1) ==1) {
                    that.btn.customs_hs=true;
                }

                if(Array.methods.getSysConfig('A104') == 1){
                    that.btn.page_free = true
                }
                if(that.$limits.authority("plv4",575, 1)>0){
                    // console.log("选项卡—机加工信息-显示")
                    that.btn.page_part_mach=true;
                }
                
                if (!that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)) {
                    //自制件不显示采购相关页签
                    if(that.dataSetDetail.mp_flag==1){
                        that.btn.page_part=false;
                    }
                    else{
                        if (that.$limits.authority('plv2', 43, 1) ==1) {
                            that.btn.page_part=true;
                            that.btn.page_part_readonly=true;
                        }
                        if (that.$limits.authority('plv2', 43, 1) ==2) {
                            that.btn.page_part=true;
                            if (that.$limits.authority('plv3', 43, 1) >0) {
                                that.btn.page_part_readonly=true;
                            }
                        }
                        if (that.$limits.authority('plv4', 135, 1) ==1 && that.dataSetDetail.p_part_valid_flag=='无效') {
                            that.btn.p_part_effective=true;
                        }
                        else{
                            that.btn.p_part_effective=false;
                        }
                        if (that.$limits.authority('plv4', 136, 1) ==1 && that.dataSetDetail.p_part_valid_flag=='有效') {
                            that.btn.p_part_invalid=true;
                        }
                        else{
                            that.btn.p_part_invalid=false;
                        }
                    }
                    
                }
                else{
                    that.btn.page_part=false;
                    that.btn.page_part_readonly=false;
                    that.btn.p_part_effective=false;
                    that.btn.p_part_invalid=false;
                }


                //当前库存成本020510
                if(!that.$limits.SpecialAuthority(323, true)){
                    that.btn.inv_cost=false;
                }else{
                    that.btn.inv_cost=true;
                }
                //基础信息020508              
                if(!that.$limits.SpecialAuthority(83, true)){
                    // console.log("基础信息-不显示")
                    that.btn.page_master=false;
                }else{
                    //020514
                    if(!that.$limits.SpecialAuthority(354, true)){
                        // console.log("基础信息-只读")
                        that.btn.readonly_page_master=false;
                    }
                }
                //计划相关020505
                if(!that.$limits.SpecialAuthority(2, true)){
                    that.btn.page_schedule=false;
                }                
                else{//020511
                    if(!that.$limits.SpecialAuthority(351, true)){
                        that.btn.readonly_page_schedule=false;
                    }
                }
                //成本相关020506                 
                if(!that.$limits.SpecialAuthority(3, true)){
                    // console.log("成本相关-不显示")
                    that.btn.page_cost=false;
                }else{
                    //020512
                    if(!that.$limits.SpecialAuthority(352, true)){
                        // console.log("成本相关-只读")
                        that.btn.readonly_page_cost=false;
                    }
                }                
                //其它020507                
                if(!that.$limits.SpecialAuthority(4, true)){
                    // console.log("其它-不显示")
                    that.btn.page_quality=false;
                }
                else{
                    //020513
                    if(!that.$limits.SpecialAuthority(353, true)){
                        // console.log("其它-只读")
                        that.btn.readonly_page_quality=false;
                    }
                }         
                //表头信息020515                
                if(!that.$limits.SpecialAuthority(355, true)){
                    that.btn.page_header=false;
                }   
                //成本权限
                if(!that.btn.inv_cost){
                    that.btn.inv_cost_qx=false;
                }
                else if(!that.btn.readonly_page_cost){
                    that.btn.inv_cost_qx=true;
                }
                else
                {
                    that.btn.inv_cost_qx=true;
                }
                if(that.$limits.authority('plv4', 153, 1) == 1){
                    that.btn.updateaccumulate=true;
                }else{
                    that.btn.updateaccumulate=false;
                }
                //查看图纸权限
                if (!that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)) {
                    if(that.$limits.authority('plv4', 104, 1) == 1){
                        that.btn.lookdrawing=true;
                    }else{
                        that.btn.lookdrawing=false;
                    }
                }
                else{
                    that.btn.lookdrawing=false;
                }
                if(that.selectData.length>0){
                    if (that.$limits.authority('plv3', 29, 1) == 0) {
                        that.btn.batach=false;
                    }
                    else{
                        if(that.$limits.authority('plv4', 1, 1) == 0){
                            that.btn.batach=false;
                        }
                    }
                }
                else{
                    that.btn.batach=false;
                }

                if (that.$limits.authority('plv3', 30, 1) == 0) {
                    //设为可用
                    that.btn.usable=false;
                    //设为不可用
                    that.btn.nousable=false;
                }
                else{
                     //物料状态 020504                
                    if(!that.$limits.SpecialAuthority(1, true)){                        
                        //设为可用
                        that.btn.usable=false;
                        //设为不可用
                        that.btn.nousable=false;
                    }
                    else{
                        if (that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)) {
                            //设为可用
                            that.btn.usable=false;
                            //设为不可用
                            that.btn.nousable=false;
                        }
                        else{
                            if(that.dataSetDetail.part_status==1){
                                 //设为可用
                                that.btn.usable=false;
                                //设为不可用
                                that.btn.nousable=true;
                            }
                            else{
                                //设为可用
                                that.btn.usable=true;
                                //设为不可用
                                that.btn.nousable=false;
                            }
                        }
                    }
                }


                if(!that.btn.page_header){
                    if(that.dataSetDetail.part_status == 0){
                        that.btn.partname = true
                    } else {
                        that.btn.partname = false
                        that.btn.partversion = false
                        that.btn.mpflag = false
                    }
                } else {
                    if(that.dataSetDetail.exclusively_id == '' || that.dataSetDetail.exclusively_id == 0){
                        that.btn.partname = true
                        that.btn.partversion = true
                        that.btn.mpflag = true
                    }
                }
            },
            
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            fileChange(file, fileList) {
                let that = this;
                that.file = file.raw;
            },
            handleRemove(file, fileList) {
                let that = this;
                that.dataSetDetail.part_picpath = '';
            },
            handlePictureCardPreview(file) {
                let that = this;
                that.dialogImageUrl = file.url;
                that.dialogVisible = true;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('mater',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            search() {
                let that = this;
                that.isVisible = true;
                // if(that.SelectIndex==4){
                //     that.$refs.ser.clearInput(that.isVisible, 'SchPPartViewInfo');
                // }
                // else{
                    that.$refs.ser.clearInput(that.isVisible, 'PartViewInfo');
                // }
            },
            reflash() {
                let that = this;
                if(that.oldDataSetDetail != JSON.stringify(that.dataSetDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//数据已发生变更，是否保存后刷新？
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 1){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            del() {
                this.$confirm(this.$t('getapi[8573]'), this.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: this.$t('getapi[1146]'),
                    cancelButtonText: this.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let that = this;
                        let token = JSON.parse(that.userData).token;
                        let str = '';
                        for (let i = 0; i < that.selectIDData.length; i++) {
                            str = str + that.selectIDData[i] + ',';
                        }
                        str = str.substr(0, str.length - 1);
                        $.ajax({
                            url: Common.Url + 'Eng/Parts/BatchDeletePart?token=' + token + '&ids=' + str,
                            type: 'post',
                            contentType: 'application/json',
                            success: function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getView();
                                } else {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            },
                            error: function (xhr, errorType, error) {
                                that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('getapi[8574]')
                        });
                    });
            },
            print() {
                let that = this;
                let token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + 'Eng/Parts/Print?token=' + token,
                    type: 'post',
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL + '?timestamp=' + new Date().getTime();
                            window.open(hrefurl);
                        } else {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            selectEmployee() {
                let that = this;
                that.employeeVisible = true;
                that.$refs.employee.clearInput(this.employeeVisible);
            },
            getemployee(data) {
                let that = this;
                that.dataSetDetail.p_part_buyer = data.name;
            },
            selectCargo() {
                let that = this;
                that.cargoVisible = true;
                that.$refs.cargo.clearInput(this.cargoVisible);
            },
            getcargo(data) {
                let that = this;
                that.dataSetDetail.cargoposition_code = data.cargoposition_code;
            },

            imp() {
            },
            //导出
            expjq() {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                $.ajax({
                    url: Common.Url + 'Eng/Parts/ExportToExecl?token=' + token,
                    type: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        that.loading = false;
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });

                /*let that = this;
                let datac = [];
                let fname = ''
                if(that.SelectIndex == 0){
                    fname = that.$t('getapi[3608]')
                } else if(that.SelectIndex == 1){
                    fname = that.$t('getapi[148]')
                } else if(that.SelectIndex == 2){
                    fname = that.$t('getapi[167]')
                } else if(that.SelectIndex == 3){
                    fname = that.$t('getapi[184]')
                } else if(that.SelectIndex == 4){
                    fname = that.$t('getapi[6110]')
                }
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PartViewInfo",
                    fromname: fname,
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            //导入
            impt() {

                let item = {
                    //label: '物料主文件导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/2',
                    url: '/exp/2',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/2'});
                this.$store.commit('selectMenu', item);
            },
            imptMachData(){
                let item = {
                    //label: '物料机加工信息',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/47',
                    url: '/exp/2',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/47'});
                this.$store.commit('selectMenu', item);
            },
            add() {
                let that = this;
                if(that.oldDataSetDetail != JSON.stringify(that.dataSetDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//数据已发生变更，是否保存后新建？
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.isEdit = false;
                that.addoredit = 0
                that.part_status = true;
                that.fileList = [];
                that.fileHSList = [];
                that.code=''
                that.dataSetDetail = {
                    safedays: '',
                    exclusively_id: 0,
                    create_time: datetime,
                    abc_category: 'B',
                    keep_period_flag: false,
                    part_code: '',
                    field: '',
                    part_name: '',
                    item_type_id: '',
                    finance_type_id: '',
                    commodity_type_id: '',
                    dummy_flag: false,
                    isstock: true,
                    islotnumbertrace: false,
                    issequencetrace: false,
                    part_model: '',
                    part_spec: '',
                    page_no: '',
                    part_stuff: '',
                    part_master_unit: '',
                    part_assist_unit: '',
                    assist_unit_flag: false,
                    barcode: '',
                    blueprint_code: '',
                    weight: 0,
                    cubage: 0,
                    part_version: 'A',
                    part_status: 0,
                    mp_flag: 1,
                    stuff_manuf_code: '',
                    stuff_manuf_name: '',
                    cycle_check_interval: 0,
                    least_purch_batch: 0,
                    require_period: 0,
                    planning_period: 0,
                    stock_upperlimit: 0,
                    item_code: '',
                    item_duty_person:'',
                    create_person: '',
                    last_modify_person: '',
                    master_assist_rate: 1,
                    board_flag: 0,
                    category_firstname: '',
                    category_first: '',
                    category_secondname: '',
                    category_second: '',
                    category_thirdname: '',
                    category_third: '',
                    leftover_flag: 0,
                    ce_flag:0,
                    zerocost_flag: 0,
                    part_area: 0,
                    bom_config_flag: 0,
                    bom_config_sign: '',
                    digitscale: 0,
                    products: '',
                    saledemandflag: false,
                    key_flag: 0,
                    avl_flag: 0,
                    trackname: '',
                    qc_leadtime: 0,
                    stock_lowerlimit: 0,
                    stock_lowest: 0,
                    standard_batch: 0,
                    year_batch: 0,
                    produce_leadtime: 0,
                    safe_days: 0,
                    purchase_leadtime: 0,
                    is_cycle_check: false,
                    so_issue_control: '1',
                    mergedays: 1,
                    planning_code: 'MRP',
                    planner_id: 0,
                    plannername: '', //保存时去掉这个字段
                    package_qty: 0,
                    relation_partmaster_id: '',
                    cost_mode_id: 1,
                    lately_purch_cost: 0,
                    average_purch_cost: 0,
                    inv_cost: 0,
                    inv_cost_material: 0,
                    inv_cost_man: 0,
                    inv_cost_charge: 0,
                    keep_longest_period: 0,
                    check_std: '',
                    quality_std: '',
                    cargoposition_code: '',
                    material_standard: '',
                    part_picpath: '',
                    p_part_exclusively_id:0,
                    p_part_relation_partmaster_id:0,
                    p_part_sort_id :this.schPPpartTypeListArray[0].Code,
                    p_part_year_quantity:'',
                    p_part_pur_measurementunit :this.allUnitsArray[0].Code,
                    p_part_remark:'',
                    p_part_create_person :'',
                    p_part_create_time:'',
                    p_part_modify_person:'',
                    p_part_modify_time:'',
                    p_part_buyer:'',
                    p_part_valid_flag:'',
                    method: '发料量',
                    Accumulate_LEADTIME: '',
                    LEADTIME_ManFlag: 0,
                    p_mach_exclusively_id:0,
                    p_mach_relation_partmaster_id:0,
                    confirm_date:'',
                    malaysia_canmake:0,
                    prefix:'',
                    suffix:'',
                    digit:'',
                    currentvalue:'',
                    mrp_fa_flag: 0,
                    machine_flag: 0,
                    nodirect_move_cross_plan:0,
                    total_lead_time:0,
                    raw_material_time:0,
                    print_flag:0,
                    customs_hscode:'',
                    cus_draw_version:'',
                    cusitem_name:'',
                    decl_elem:'',
                    country_origin:'',
                    decl_productname:'',
                    msds_flag:0,
                };
                that.dataGDetail = []
                that.dataHSList = []                
                that.oldDataSetDetail = JSON.stringify(that.dataSetDetail)
                that.setCurrent('');
                that.authority();
            },
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Eng/Parts/DataList', data, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        /*that.$limits.selecttd();*/
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    } else {
                        // that.$message.error(res.Msg);
                        that.loading = false;
                    }
                });
            },
            // 批量设为可用
            setInvalidBatch() {
                let that = this;
                let parm = [];
                for (let i = 0; i < that.selectData.length; i++) {
                    parm = [
                        ...parm,
                        {
                            exclusively_id: that.selectData[i].Exclusively_ID,
                            part_code: that.selectData[i].part_code,
                            part_version: that.selectData[i].part_version,
                            field: that.selectData[i].FIELD,
                            LangType: that.$processdata.getLang(),
                        }
                    ];
                }
                that.$http.urlpost('/Eng/Parts/BatchUpdateStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView();
                    }
                });
            },
            // 更新所有料累积生产提前期
            UpdateAccumulateLEADTIME() {
                let that = this;
                that.btn.updateaccumulate=false;
                that.$confirm(that.$t('getapi[8578]'), that.$t('getapi[194]'), {//确认要更新吗？时间可能较长
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                .then(() => {                    
                    that.$http.urlpost('/Eng/Parts/UpdateAccumulateLEADTIME', null, res => {
                        if (res.Success == 1) {
                            that.btn.updateaccumulate=true;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getView();                            
                        }
                    });
                })
                
            },
            
             //获取特殊权限
            getSpecialauthority(id) {
                let that = this;
                let iResult=-10;
                let enable=false;
                let parm = [];
                parm = {
                    perid:id
                }           
                that.loading=true;     
                that.$http.urlpost('/Eng/Parts/GetPartAuthority', parm, function (res) {
                    if (res.Success == 1) {
                        iResult=res.DataContent.iResult; 
                        that.loading=false;
                        if(id=="020504"){
                            enable=true;
                        }
                        //基础信息
                        else if(id=="020508"){
                            enable=true;
                        }
                        //计划相关
                        else if(id=="020505"){
                            enable=true;
                        }
                        //成本相关
                        else if(id=="020506"){
                            enable=true;
                        }
                        //其它
                        else if(id=="020507"){
                            enable=true;
                        }
                         //表头信息
                        else if(id=="020515"){
                            enable=true;
                        }
                        that.btnSpecialAuthority(id,iResult,enable);
                    }
                });
                return iResult;
            },
            // 物料主文件设置可用不可用
            setInvalid(value) {
                let that = this;
                if (value == 1) {
                    let parm = {
                        exclusively_id: that.dataSetDetail.exclusively_id,
                        part_code: that.dataSetDetail.part_code,
                        part_version: that.dataSetDetail.part_version,
                        LangType: that.$processdata.getLang(),
                    };
                    that.$http.urlpost('/Eng/Parts/UpdateStatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getDetail(that.code);
                            that.getView();
                        }
                    });
                } else if (value == 0) {
                    let item = {
                        name: 'invalidsetting',
                        path: '/invalidsetting',
                        label: that.$t('getapi[60]')
                    };
                    this.$store.commit('selectMenu', item);
                    this.$router.push(item);
                }
            },
            //查看图纸文件
            lookdrawing(){
                let that=this;
                that.btn.lookdrawing=false;
                let parm = {
                        exclusively_id: that.dataSetDetail.exclusively_id,
                        part_code: that.dataSetDetail.part_code
                    };
                    that.$http.urlpost('/Eng/Parts/GetPartSearchPDF', parm, function (res) {
                        if (res.Success == 1) {
                            // console.log(that.$t('getapi[6453]')+":"+res.DataContent)
                            // that.$message.success(res.Msg);
                            if(!that.$limits.fnIsEmpty(res.DataContent)){
                                window.open(Common.Url + res.DataContent);
                            }
                        }
                        else if(res.Success == 2){
                            if(!that.$limits.fnIsEmpty(res.DataContent)){
                                window.open(Common.FileUrl + res.DataContent);
                            }
                        }
                        that.btn.lookdrawing=true;
                    });
            },
            //采购件状态设置：1 有效、0 无效
            setEffective(value){
                let that = this;
                if (value == 1) {
                    let parm = {
                        part_id: that.dataSetDetail.exclusively_id,
                        part_code: that.dataSetDetail.part_code,
                        exclusively_id: that.dataSetDetail.p_part_exclusively_id
                    };
                    that.$http.urlpost('/Eng/Parts/UpdateSchPPartEffective', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getDetail(that.code);
                            that.getView();
                        }
                    });
                } else if (value == 0) {
                    let parm = {
                        exclusively_id: that.dataSetDetail.p_part_exclusively_id
                    };
                    that.$http.urlpost('/Eng/Parts/UpdateSchPPartInvalid', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getDetail(that.code);
                            that.getView();
                        }
                    });
                }
            },
            editInfo(row) {
                let that = this;
                if(that.code == row.Exclusively_ID){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(that.oldDataSetDetail != JSON.stringify(that.dataSetDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//数据已发生变更还未保存，是否切换？
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.isEdit = true;
                                that.oldSelectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.Exclusively_ID
                                that.getDetail(row.Exclusively_ID);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.oldSelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 3) {
                                    that.$refs.singleTable3.$refs.singleTable.setCurrentRow(that.oldrow);
                                }else if (that.oldSelectIndex == 4) {
                                    that.$refs.singleTable4.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                                that.activeName = that.oldSelectIndex
                            });
                    } else {
                        that.isEdit = true;
                        that.oldSelectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.Exclusively_ID
                        that.getDetail(row.Exclusively_ID);
                    }
                }, 100);
            },
            // 获取物料详情
            getDetail(id) {
                let that = this;
                if (that.$limits.authority('plv2', 30, 1) <1) {
                    return;
                }
                that.addoredit = 1
                let parm = {
                    Id: id,
                    Code: '',
                    Name: '',
                    Where: ''
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Eng/Parts/GetAllInfoByID', parm, function (res) {
                    if (res.Success == 1) {
                        that.b_assist_unit_flag=res.DataContent.b_assist_unit_flag;
                        that.partCategory_BArray=res.DataContent.category_second;
                        that.partCategory_CArray=res.DataContent.category_third;
                        that.dataPPartDetail = res.DataContent.PLines;
                        that.dataGDetail = res.DataContent.GLists;
                        that.dataHSList= res.DataContent.HSList;
                        that.dataSetDetail = res.DataContent.Lines[0];
                        that.dataSetDetail.inv_cost = that.dataSetDetail.inv_cost.toFixed(4);
                        that.dataSetDetail.inv_cost_material = that.dataSetDetail.inv_cost_material.toFixed(4);
                        that.dataSetDetail.inv_cost_man = that.dataSetDetail.inv_cost_man.toFixed(4);
                        that.dataSetDetail.inv_cost_charge = that.dataSetDetail.inv_cost_charge.toFixed(4);
                        that.dataSetDetail.bom_config_flag = that.dataSetDetail.bom_config_flag.toString()
                        that.dataSetDetail.board_flag = that.dataSetDetail.board_flag.toString()
                        that.dataSetDetail.avl_flag = that.dataSetDetail.avl_flag.toString()
                        that.dataSetDetail.malaysia_canmake = that.dataSetDetail.malaysia_canmake.toString()                        
                        that.dataSetDetail.leftover_flag = that.dataSetDetail.leftover_flag.toString()
                        that.dataSetDetail.ce_flag = that.dataSetDetail.ce_flag.toString()
                        that.dataSetDetail.key_flag = that.dataSetDetail.key_flag.toString()
                        that.dataSetDetail.so_issue_control = that.dataSetDetail.so_issue_control.toString()
                        that.dataSetDetail.nodirect_move_cross_plan = that.dataSetDetail.nodirect_move_cross_plan.toString()
                        if (that.dataSetDetail.part_picpath != null && that.dataSetDetail.part_picpath != '') {
                            that.dialogImageUrl = Common.FileUrl + that.dataSetDetail.part_picpath;
                            that.fileList = [
                                {
                                    name: '',
                                    url: that.dialogImageUrl
                                }
                            ];
                        } else {
                            that.dialogImageUrl = '';
                            that.fileList = [];
                        }
                        if (that.dataSetDetail.part_status == 1) {
                            that.part_status = true;
                        } else {
                            that.part_status = false;
                        }
                        if (that.dataSetDetail.islotnumbertrace == true) {
                            that.tracetype = 1
                        } else if (that.dataSetDetail.issequencetrace == true) {
                            that.tracetype = 2
                        } else {
                            that.tracetype = 0
                        }
                        that.oldDataSetDetail = JSON.stringify(that.dataSetDetail)

                        that.authority();
                        that.selectbtn();
                    }
                    loadingInstance.close()
                });
            },
            selectInfo(tab, event) {
                let that = this;
                if (that.activeName ==0) {
                    that.SelectIndex = 0;
                    that.tabNo="0";
                    that.title=that.$t('getapi[55]')+'('+that.$t('getapi[3608]')+')'//"物料主文件(基础信息)";
                } else if (that.activeName ==1) {
                    that.SelectIndex = 1;
                    that.tabNo="1";
                    that.title=that.$t('getapi[55]')+'('+that.$t('getapi[148]')+')'//"物料主文件(计划相关)";
                } else if (that.activeName ==2) {
                    that.SelectIndex = 2;
                    that.tabNo="2";
                    that.title=that.$t('getapi[55]')+'('+that.$t('getapi[167]')+')'//"物料主文件(成本相关)";
                } else if (that.activeName ==3) {
                    that.SelectIndex = 3;
                    that.tabNo="3";
                    that.title=that.$t('getapi[55]')+'('+that.$t('getapi[184]')+')' //"物料主文件(质量相关)";
                }
                else if (that.activeName ==4) {
                    that.SelectIndex = 4;
                    that.tabNo="4";
                    that.title=that.$t('getapi[55]')+'('+that.$t('getapi[6110]')+')'//"物料主文件(采购相关)";
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
                that.selectbtn();
                that.colsort();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].Exclusively_ID);
                }
                that.selectbtn();
            },
            save() {
                let that = this;
                var SaveRight = false;
                if (that.$limits.authority('plv2', 30, 1) == 2) {
                    if (that.$limits.authority('plv3', 30, 1) > 0) {
                        SaveRight = true;
                    }
                }
                if (!SaveRight) {
                    that.$message.warning(that.$t('getapi[233]'));//'无保存权限！'
                    return;
                }
                that.clicks = true;
                let token = JSON.parse(that.userData).token;
                let data ={
                    head:that.dataSetDetail,
                    plines:that.dataPPartDetail,
                    glists: that.dataGDetail
                }
                if (data.head.digitscale < 0 || data.head.digitscale > 4) {
                    that.$message.warning(that.$t('getapi[234]'));//'圆整率必须为0到4的整数。'
                    return;
                }
                if (data.head.part_code == undefined || data.head.part_code == '') {
                    that.$message.warning(that.$t('getapi[750]'));//物料编码不能为空！
                    return;
                }
                if (data.head.part_version == undefined || data.head.part_version == '') {
                    that.$message.warning(that.$t('getapi[253]'));//'物料版本不能为空！'
                    return;
                }
                if (data.head.abc_category == undefined || data.head.abc_category == '') {
                    that.$message.warning(that.$t('getapi[254]'));//'ABC分类不能为空！'
                    return;
                }
                if (data.head.abc_category == undefined || data.head.part_master_unit == '') {
                    that.$message.warning(that.$t('getapi[255]'));//'主计量单位不能为空！'
                    return;
                }
                if (data.head.abc_category == undefined || data.head.item_code == '') {
                    that.$message.warning(that.$t('getapi[256]'));//'项目代号不能为空！'
                    return;
                }
                if (data.head.category_first == undefined || data.head.category_first == '') {
                    that.$message.warning(that.$t('getapi[317]'));//'存货类别1不能为空！'
                    return;
                }
                if (data.head.mp_flag == 0) {
                    /*if (data.purchase_leadtime == undefined || data.purchase_leadtime == '') {
                        that.$message.warning('采购提前期必须填写。');
                        return;
                    }*/
                    if (data.head.purchase_leadtime < 0) {
                        that.$message.warning(that.$t('getapi[8579]'));//'采购提前期必须大于等于零。'
                        return;
                    }
                }
                if (data.head.mp_flag == 1) {
                    /*if (data.produce_leadtime == undefined || data.produce_leadtime == '') {
                        that.$message.warning('生产提前期必须填写。');
                        return;
                    }*/
                    if (data.head.produce_leadtime < 0) {
                        that.$message.warning(that.$t('getapi[8580]'));//'生产提前期必须大于等于零。'
                        return;
                    }
                    let flag = true
                    for(let i = 0;i<that.partCategory_AArray.length;i++){
                        if(data.head.category_first == that.partCategory_AArray[i].Code){
                            if(that.partCategory_AArray[i].Name == '产成品' || that.partCategory_AArray[i].Name == '半成品'){
                                flag = false
                            }
                        }
                    }
                    if (flag) {
                        that.$message.warning(that.$t('getapi[8581]'));//'物料类别为自制件的存货类别只能为产成品或半成品。'
                        return;
                    }
                }
                /*if (data.least_purch_batch > data.standard_batch) {
                    that.$message.warning('最小批量不能大于标准批量。');
                    return;
                }*/
                if (data.head.assist_unit_flag) {
                    if (data.head.part_assist_unit == undefined || data.head.part_assist_unit == '') {
                        that.$message.warning(that.$t('getapi[249]'));//次计量单位可用时 次计量单位不能为空！
                        return;
                    }
                    if (data.head.master_assist_rate == undefined || data.head.master_assist_rate < 0) {
                        that.$message.warning(that.$t('getapi[250]'));//'次计量单位可用时 换算率不能小于等于零！'
                        return;
                    }
                }
                let reg = new RegExp('^[0-9a-zA-Z_-_.]{1,}$');

                // if (!reg.test(data.head.part_code)) {
                //     that.$message.warning('物料编码含有非法字符。(只允许字母、数字、- 以及下划线)');
                //     return;
                // }
                if (data.head.mp_flag == 0) {
                    if (data.head.dummy_flag == true) {
                        that.$message.warning(that.$t('getapi[257]'));//'采购件不能为虚拟件！'
                        return;
                    }
                }
                if (data.head.part_master_unit == data.head.part_assist_unit) {
                    that.$message.warning(that.$t('getapi[263]'));//'主计量单位和次计量单位不能相同！'
                    return;
                }
                if (that.tracetype == 2 && data.head.assist_unit_flag == true) {
                    that.$message.warning(that.$t('getapi[8582]'));//'启用次计量和序列号跟踪不能同时打勾！'
                    return;
                }
                if (data.head.mergedays == undefined || data.head.mergedays == '') {
                    that.$message.warning(that.$t('getapi[265]'));//'必须输入合并天数！'
                    return;
                }
                if (data.head.mergedays != undefined) {
                    if (data.head.mergedays.toString().split('.').length > 1) {
                        that.$message.warning(that.$t('getapi[266]'));//'合并天数的格式错误！'
                        return;
                    }
                }
                if (data.head.qc_leadtime != undefined) {
                    if (data.head.qc_leadtime.toString().split('.').length > 1) {
                        that.$message.warning(that.$t('getapi[8583]'));//'质检天数的格式错误！'
                        return;
                    }
                }
                if (data.head.keep_period_flag == true && that.tracetype != 1) {
                    that.$message.warning(that.$t('getapi[279]'));//'批号跟踪必须打勾！'
                    return;
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                delete data.head.plannername;
                that.$http.urlpost('Eng/Parts/SaveData', data, function (res1) {
                    if (res1.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                        that.code = res1.UniqueNum
                        that.getDetail(res1.UniqueNum);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res1.Msg));
                    }
                    that.clicks = false;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
                /*let formData = new FormData(); //formdata格式
                        formData.append('file', that.file);
                        that.$http.urlpost('/Basic/UploadFileResult', formData, function(res) {
                            if (res.Success == 1) {
                                that.dataSetDetail.part_picpath = res.FielPath;

                            } else {
                                that.$message.error(res.Msg);
                            }
                        });*/
                /* $.ajax({
                                url: Common.Url + '?token=' + token,
                                type: 'post',
                                data: JSON.stringify(data),
                                contentType: 'application/json',
                                success: function(res) {

                                },
                                error: function(xhr, errorType, error) {
                                    that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                                }
                            }); */
            },
            uploadFile() {
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                that.$http.urlpost('/Basic/UploadFileResult', formData, function (res) {
                    if (res.Success == 1) {
                        console.log(res.FielPath);
                        that.dataSetDetail.part_picpath = res.FielPath;
                        if (!that.$limits.fnIsEmpty(that.dataSetDetail.exclusively_id)){
                            that.save();
                        }
                    }
                });
            },
            // handleCurrentChange(val) {
            // 	let that = this;
            // 	that.pageIndex = val;
            // 	that.getView();
            // },
            costChange() {
                let that = this;
                that.dataSetDetail.inv_cost =
                    parseFloat(that.dataSetDetail.inv_cost_material) + parseFloat(that.dataSetDetail.inv_cost_man) + parseFloat(that.dataSetDetail.inv_cost_charge);
            },
            changempflag() {
                let that = this;
                that.dataSetDetail = {...that.dataSetDetail};
                that.dataSetDetail.dummy_flag = false;
                //自制件不显示采购相关页签
                if(that.dataSetDetail.mp_flag==1){
                    that.btn.page_part=false;
                }
            },
            changeTraceType() {
                let that = this;
                if (that.tracetype == 1) {
                    that.dataSetDetail.islotnumbertrace = true;
                    that.dataSetDetail.issequencetrace = false;
                } else if (that.tracetype == 2) {
                    that.dataSetDetail.islotnumbertrace = false;
                    that.dataSetDetail.issequencetrace = true;
                } else {
                    that.dataSetDetail.islotnumbertrace = false;
                    that.dataSetDetail.issequencetrace = false;
                }
            },
            changeCateroty() {
                let that = this;
                that.dataSetDetail.category_second = null;
                that.dataSetDetail.category_third = null;
                let data = {
                    Id: 0,
                    Code: that.dataSetDetail.category_first,
                    Name: '',
                    Where: ''
                };
                that.userData = sessionStorage.getItem('userData');
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + 'Basic/GetPartCategory_BC?token=' + that.token,
                    type: 'post',
                    data: JSON.stringify(data),
                    async: false,
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            that.partCategory_BArray = res.DataContent;
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            changeCateroty1() {
                let that = this;
                let data = {
                    Id: 0,
                    Code: that.dataSetDetail.category_second,
                    Name: '',
                    Where: ''
                };
                that.userData = sessionStorage.getItem('userData');
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + 'Basic/GetPartCategory_BC?token=' + that.token,
                    type: 'post',
                    data: JSON.stringify(data),
                    async: false,
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            that.partCategory_CArray = res.DataContent;
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            selectPlanner() {
                let that = this;
                if(!that.btn.readonly_page_schedule){
                    return ;
                }
                that.isVisiblePlanner = true;
                that.$refs.planner.clearInput(that.isVisiblePlanner);
            },
            getPlanner(data) {
                let that = this;
                console.log(data)
                that.dataSetDetail.planner_id = data.Num
                that.dataSetDetail.plannername = data.Name;
            },
            selectItemCode() {
                let that = this;
                if(!that.btn.readonly_page_master){
                    return;
                }
                that.isVisibleItem_code = true;
                that.$refs.itemcode.clearInput(that.isVisibleItem_code);
            },
            getItemCode(data) {
                let that = this
                console.log(data)
                that.dataSetDetail.item_code = data.ITEM_CODE
                that.dataSetDetail.item_duty_person = data.ITEM_DUTY_PERSON
            },
            /*// 获取项目代号
            getENGITEMList() {
                let that = this;
                let data = {
                    PageIndex: that.pageIndexItem_code,
                    PageSize: that.pageSizeItem_code,
                    SelectIndex: 0,
                    Param: {
                        Id: 0,
                        Code: that.querykeyItem_code,
                        Name: that.querykeyItem_code,
                        Where: ''
                    }
                };
                that.$http.urlpost('Basic/GetENGITEMList', data, function(res) {
                    if (res.Success == 1) {
                        that.ENGITEMListArray = res.DataContent;
                        that.totalItem_code = res.Totals;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            handleSizeChangeItem_code(val) {
                this.pageSizeItem_code = val;
                this.getENGITEMList();
            },
            handleCurrentChangeItem_code(val) {
                this.pageIndexItem_code = val;
                this.getENGITEMList();
            },
            changeItem_code(row) {
                let that = this;
                that.cacheItem_code = row.Code;
            },
            confirmItem_code() {
                let that = this;
                that.dataSetDetail.item_code = that.cacheItem_code;
                that.isVisibleItem_code = false;
            },*/
            // 当物料类别为采购件时，虚拟件不能勾选
            checkDummyAndStock(val) {
                let that = this;
                if (val == true && that.dataSetDetail.mp_flag == 0) {
                    that.$message.warning(that.$t('getapi[8584]'));//'采购件不能是虚拟件！'
                    that.dataSetDetail.dummy_flag = false;
                }
            },
            //可用去除勾选时清空次计量单位和参考换算率
            assistunitflagChange(val) {
                let that = this
                console.log(val)
                if (val == 0) {
                    that.dataSetDetail.part_assist_unit = ''
                    that.dataSetDetail.master_assist_rate = 1
                }
            },
            //自由项
            handleSelectionChangeG({ records }) {
                let that = this;
                that.selectDataG = records
            },
            addG(){
                let that = this
                that.dataGDetail.push({
                    exclusively_id: 0,
                    relation_partmaster_id: 0,
                    freevalue:'',
                    isenable:1,
                })
            },
            batchDelG() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.dataGDetail.splice(that.selectDataG[0].index, 1);
                        if(that.selectDataG[0].exclusively_id!=0){
                            let parm = {
                                Id: that.selectDataG[0].exclusively_id
                            }
                            that.$http.urlpost('/Eng/Parts/DeletePartGROUP', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //勾选板材件，把打印材质标记也勾选上
            changeBoardFlag(val){
                let that = this
                if(val == 1){
                    that.dataSetDetail.print_flag = 1
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 30,1) < 1){
                    return false
                }
                let flag =  that.oldDataSetDetail != JSON.stringify(that.dataSetDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    el-input {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    .el-input__inner {
        line-height: 28px;
        height: 28px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
</style>
